import { cloneDeep } from "lodash";
import { atom, selector } from "recoil";
import { authState, permissionState } from "../api/state/AuthState";
import Login from "../app/guest/Login";
import Home from "../app/auth/Home";
import ManageDock from "../app/auth/ManageDock";
import Users from "../app/auth/users"
import Roles from "../app/auth/roles"
import Permissions from "../app/auth/permissions"
import NonAuthLayout from "../components/NonAuthLayout";
import Slots from "../app/auth/slots"
import Topups from "../app/auth/topups"
import Vessels from "../app/auth/vessels"
import Zones from "../app/auth/zones"
import PermitTypes from "../app/auth/permitTypes"
import VesselTypes from "../app/auth/vesselTypes"
import PaymentSuccess from "../app/guest/PaymentSuccess";
import PaymentFailed from "../app/guest/PaymentFailed";
import ActivityHistory from "../app/auth/activityHistory";
import HarborTransaction from "../app/auth/harborTransactions";
import TransactionReports from "../app/auth/transactionReports";
import TopupReports from "../app/auth/topupReports";
import DockingRequestReports from "../app/auth/dockingRequestReports";
import VesselPermitReports from "../app/auth/vesselPermitReports";
import VesselFinder from "../app/auth/vesselFinder";
import ActivePermits from "../app/auth/activePermits";
import Customers from "../app/auth/customers";
import CustomerReports from "../app/auth/customerReports";




// import HorizontalLayout from "../components/HorizontalLayout";
// import GuestHome from "../app/guest/Home";


const navigation = [
    {
        name: 'Login',
        icon: 'bx bx-lock',
        link: '/login',
        defaultRoute: true,
        component: Login,
        layout: NonAuthLayout,
        hidden: true,
        middleware: 'guest',
        children: [],
    },
    {
        name: 'Main',
        icon: 'mdi mdi-ship-wheel',
        middleware: 'auth',
        children: [
            {
                name: 'Home',
                icon: 'mdi mdi-ship-wheel',
                link: '/home',
                defaultRoute: true,
                component: Home,
                middleware: 'auth',
                children: [],
            },
            { // Activity History Begin
                name: 'Activity History',
                icon: 'mdi mdi-history',
                link: '/activityHistories',
                component: ActivityHistory,
                middleware: 'auth',
                children: [],
            }, // Activity History End
            { // Harbor Transaction Begin
                name: 'Utilization',
                icon: 'mdi mdi-receipt',
                link: '/harborTransactions',
                component: HarborTransaction,
                middleware: 'auth',
                children: [],
            }, // Harbor Transaction End
            { // Topup Route Begin
                name: 'Topup',
                icon: 'mdi mdi-cash',
                link: '/topups',
                component: Topups,
                middleware: 'auth',
                children: [],
            }, // Topup Route End
            
            {
                name: 'Payment Success',
                icon: 'mdi mdi-application-cog',
                link: '/paymentSuccess',
                hidden: true,
                component: PaymentSuccess,
                layout: NonAuthLayout,
                children: [],
            },
            {
                name: 'Payment Failed',
                icon: 'mdi mdi-application-cog',
                link: '/paymentFailed',
                hidden: true,
                component: PaymentFailed,
                layout: NonAuthLayout,
                children: [],
            },
            { // Operations Begin — admin-only screens, each permission gated
                name: 'Operations',
                icon: "mdi mdi-anchor",
                children: [
                    {
                        name: 'Manage Dock',
                        icon: 'mdi mdi-waves',
                        link: '/manage-dock',
                        defaultRoute: true,
                        component: ManageDock,
                        middleware: 'auth',
                        permission: 'manage-dock',
                        children: [],
                    },
                    {
                        name: 'Vessel',
                        icon: 'mdi mdi-ferry',
                        link: '/vessels',
                        component: Vessels,
                        middleware: 'auth',
                        permission: 'update-vessels',
                        children: [],
                    },
                    {
                        name: 'Vessel Finder',
                        icon: 'mdi mdi-magnify',
                        link: '/vessel-finder',
                        component: VesselFinder,
                        middleware: 'auth',
                        // Its own grant: the finder exposes a vessel's whole
                        // history, owner and contacts, which is wider than the
                        // operational vessel screens.
                        permission: 'read-vesselFinder',
                        children: [],
                    },
                    {
                        name: 'Customers',
                        icon: 'mdi mdi-account-search',
                        link: '/customers',
                        component: Customers,
                        middleware: 'auth',
                        permission: 'read-customerReports',
                        children: [],
                    },
                    {
                        name: 'Active Permits',
                        icon: 'mdi mdi-shield-check',
                        link: '/active-permits',
                        component: ActivePermits,
                        middleware: 'auth',
                        permission: 'read-vessels',
                        children: [],
                    },
                ]
            }, // Operations End
            {
                name: 'Reports',
                icon: "mdi mdi-file-chart-outline",
                children: [
                    {
                        name: 'Utilization Report',
                        icon: 'mdi mdi-file-chart-outline',
                        link: '/reports/transaction',
                        component: TransactionReports,
                        middleware: 'auth',
                        permission: 'read-transactionReports',
                        children: [],
                    },
                    {
                        name: 'Customer Report',
                        icon: 'mdi mdi-file-chart-outline',
                        link: '/reports/customer',
                        component: CustomerReports,
                        middleware: 'auth',
                        permission: 'read-customerReports',
                        children: [],
                    },
                    {
                        name: 'Topup Report',
                        icon: 'mdi mdi-file-chart-outline',
                        link: '/reports/topup',
                        component: TopupReports,
                        middleware: 'auth',
                        permission: 'read-topupReports',
                        children: [],
                    },
                    {
                        name: 'Docking Request Report',
                        icon: 'mdi mdi-file-chart-outline',
                        link: '/reports/dockingRequest',
                        component: DockingRequestReports,
                        middleware: 'auth',
                        permission: 'read-dockingRequestReports',
                        children: [],
                    },
                    {
                        name: 'Vessel Permit Report',
                        icon: 'mdi mdi-file-chart-outline',
                        link: '/reports/vesselPermit',
                        component: VesselPermitReports,
                        middleware: 'auth',
                        permission: 'read-vesselPermitReports',
                        children: [],
                    },
                ]
            },
            {
                name: 'Master',
                icon: "mdi mdi-text-box",
                children: [
                    
                    { // Zone Route Begin
                        name: 'Zone',
                        icon: 'mdi mdi-map-marker',
                        link: '/zones',
                        component: Zones,
                        middleware: 'auth',
                        permission: 'read-zones',
                        children: [],
                    }, // Zone Route End
                    { // Slot Route Begin
                        name: 'Slot',
                        icon: 'mdi mdi-parking',
                        link: '/slots',
                        component: Slots,
                        middleware: 'auth',
                        permission: 'read-slots',
                        children: [],
                    }, // Slot Route End
                    { // PermitType Route Begin
                        name: 'Permit Type',
                        icon: 'mdi mdi-text-box',
                        link: '/permitTypes',
                        component: PermitTypes,
                        middleware: 'auth',
                        permission: 'read-permitTypes',
                        children: [],
                    }, // PermitType Route End
                    { // VesselType Route Begin
                        name: 'Vessel Type',
                        icon: 'mdi mdi-shape',
                        link: '/vesselTypes',
                        component: VesselTypes,
                        middleware: 'auth',
                        permission: 'read-vesselTypes',
                        children: [],
                    }, // VesselType Route End
                    
                ]
            },
            // Navigations
            
            {
                name: 'ACL',
                icon: "bx bx-group",
                children: [
                    {
                        name: 'Users',
                        icon: 'bx bx-group',
                        link: '/acl/users',
                        component: Users,
                        middleware: 'auth',
                        permission: 'read-users',
                        children: []
                    },
                    {
                        name: 'Roles',
                        icon: 'mdi mdi-account-key-outline',
                        link: '/acl/roles',
                        component: Roles,
                        middleware: 'auth',
                        permission: 'read-roles',
                        children: []
                    },
                    {
                        name: 'Permissions',
                        icon: 'bx bx-lock-open-alt',
                        link: '/acl/permissions',
                        component: Permissions,
                        middleware: 'auth',
                        permission: 'read-permissions',
                        children: []
                    },
                ]
            },
        ]
    }
];


const megaMenu = [
    // {
    //     name: 'UI Components',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Lightbox',
    //             link: '/lightbox',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Range Slider',
    //             link: '/rangeslider',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // },
    // {
    //     name: 'Applications',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Ecommerce',
    //             link: '/ecommerce',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Calendar',
    //             link: '/calendar',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // },
    // {
    //     name: 'Extra Pages',
    //     size: 4,
    //     children: [
    //         {
    //             name: 'Maintenance',
    //             link: '/maintenance',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //         {
    //             name: 'Coming Soon',
    //             link: '/comingsoon',
    //             component: GuestHome,
    //             middleware: 'guest',
    //         },
    //     ]
    // }
]

const rawNavigationState = atom({
    key: 'rawNavigationState',
    default: navigation,
});


const rawMegaMenuState = atom({
    key: 'rawMegaMenuState',
    default: megaMenu,
});





export const navigationState = selector({
    key: 'navigationState',
    get: ({ get }) => {
        let tempNavigation = cloneDeep(get(rawNavigationState))
        const isAuth = get(authState)
        const permissions = get(permissionState)
        const parseModule = (nav) => {
            let returnVal = null
            if(nav.children.length > 0){
                if((isAuth && nav.middleware === "auth" && (!nav.permission || permissions.includes(nav.permission))) || (!isAuth && (nav.middleware === "guest" )) || !nav.middleware){
                    let tempChildren = []
                    nav.children.forEach((child)=>{
                        let temp = parseModule(child)
                        if(temp){
                            tempChildren = [...tempChildren, temp]
                        }
                    })
                    returnVal = {...nav, children: tempChildren}
                }
            } else {
                if((isAuth && nav.middleware === "auth" && (!nav.permission || permissions.includes(nav.permission))) || (!isAuth && (nav.middleware === "guest")) || !nav.middleware){
                    returnVal = nav
                }
            }
            return returnVal
        }
        // Remove Nav Items based on auth and permissions
        tempNavigation = tempNavigation.map((header)=>parseModule(header)).filter(n=>n!==null);
        // Remove Empty Parents
        const filterChildren = (nav) => {
            if(nav.children.filter(c=>c.children.length > 0).length > 0){
                nav.children = nav.children.map((child)=>{
                    child = filterChildren(child)
                    return child
                })
            } else {
                nav.children = nav.children.filter(c=>(c.children.length > 0 || c.component))
            }
            return nav
        }
        tempNavigation = tempNavigation.map((header)=>filterChildren(header));
        // Remove Empty Modules
        tempNavigation = tempNavigation.filter(header=>(header.children.length > 0 || header.component))
        return tempNavigation;
    }
})

export const megaMenuState = selector({
    key: 'megaMenuState',
    get: ({ get }) => {
        let tempMegaMenu = cloneDeep(get(rawMegaMenuState))
        const isAuth = get(authState)
        const permissions = get(permissionState)
        tempMegaMenu = tempMegaMenu.map((header)=>{
            header.children = header.children.filter(c=>(isAuth && c.middleware === "auth" && (!c.permission || permissions.includes(c.permission))) || (!isAuth && (c.middleware === "guest")) || !c.middleware)
            return header
        }).filter(header=>header.children.length > 0);
        return tempMegaMenu;
    }
})
